import React, { useEffect, useRef } from 'react'
import { Input } from 'antd'
import classnames from 'classnames'
import classes from './index.module.scss'
const { style } = classes

const CareInput = (props) => {
  const {
    inputValue,
    setInputValue,
    placeholder,
    label,
    prefix,
    isValid = true,
    errorMessage,
    className,
    focus,
    onEnter,
    type,
    defaultValue,
    onFocus,
    onBlur,
    children,
    disabled,
    maxLength,
    pattern,
    inputMode,
    autoComplete,
  } = props
  const inputRef = useRef()

  useEffect(() => {
    if (focus) {
      inputRef.current.focus()
    }
  }, [focus])

  // antd's Input.Password ships the show/hide-characters eye toggle and
  // manages the underlying input type itself (so `type` must not be passed).
  // Renders inside an ant-input-affix-wrapper, same as our existing `prefix`
  // usages, so .personal-input's wrapper styles already apply.
  const isPassword = type === 'password'
  const InputComponent = isPassword ? Input.Password : Input

  return (
    <div className={classnames(style, className)}>
      {label && <div className='care-input-label'>{label}</div>}
      <InputComponent
        rootClassName={classnames('personal-input')}
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value)
        }}
        placeholder={placeholder}
        prefix={prefix}
        status={isValid ? '' : 'error'}
        type={isPassword ? undefined : type || 'text'}
        controls={false}
        ref={(input) => {
          inputRef.current = input
        }}
        defaultValue={defaultValue}
        onKeyDown={(e) => {
          if (onEnter && e.keyCode === 13) {
            onEnter?.()
          }
        }}
        onFocus={onFocus}
        onBlur={onBlur}
        maxLength={maxLength}
        disabled={disabled}
        pattern={pattern}
        inputMode={inputMode}
        autoComplete={autoComplete}
      />
      {!isValid && <div className='error-message'>{errorMessage}</div>}
      {children}
    </div>
  )
}

export default CareInput
